import React from 'react';
import {
    Row,
    Col,
    Breadcrumb,
    Button
} from 'react-bootstrap';
import {
    Doughnut,
    Bar
} from '../react-chartjsx/src'; //'react-chartjsx';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import {
    deviceService
} from '../../services';

import './ClusterDetail.css';

import happy from '../../assets/Happy_Smiley.png';
import sad from '../../assets/Sad_Smiley.png';
import neutral from '../../assets/Neutral_Smiley.png';
//import logo from '../../assets/Total_Logo.png';

const clusterDetail = (props) => {

    let positivePrecentage = 0.0;
    let chartReference = null;
    let chartReferenceLastWeek = null;
    let chartTitleReference = null;
    let chartTitleReferenceLastWeek = null;

    // Dougnut Parameters
    let doughnutData = {
        datasets: [{
            data: [0, 0, 0],
            /*borderColor: [
                "rgba(238, 41, 48, 0.4)",
                "rgba(245, 238, 52, 0.4)",
                "rgba(71, 183, 73, 0.4)",
            ],
            backgroundColor: [
                "rgba(238, 41, 48, 1.0)",
                "rgba(245, 238, 52, 1.0)",
                "rgba(71, 183, 73, 1.0)",
            ],
            hoverBorderColor: [
                "white",
                "white",
                "white",
            ],
            hiverBackgroundColor: [
                "rgba(238, 41, 48, 1.0)",
                "rgba(245, 238, 52, 1.0)",
                "rgba(71, 183, 73, 1.0)",
            ],
            borderWidth: 1,
            hoverBorderWidth: 3,*/
            backgroundColor: [
                '#EE2930',
                '#F5EE34',
                '#47B749'
            ],
            hoverBackgroundColor: [
                '#EE2930',
                '#F5EE34',
                '#47B749'
            ]
        }],
        labels: ['Sad', 'Neutral', 'Happy']
    };

    const doughnutPlugins = [{
        afterDraw: (chartInstance, easing) => {
            const ctx = chartInstance.chart.ctx;
            const x = chartInstance.width / 2 - 20;
            const y = chartInstance.height / 2;

            ctx.font = 'bold 20px Arial';
            ctx.fillText(positivePrecentage.toFixed(0) + '%', x, y);
            ctx.font = 'normal 10px Arial';
            ctx.fillText('Positive', x, y + 15);
        }
    }];

    const doughnutOptions = {
        maintainAspectRatio: true,
        legend: {
            display: false
        },
        cutoutPercentage: 75,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    let label = data.labels[tooltipItem.index] || '';
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                    if (label) {
                        label += ': ';
                    }
                    label += value.toFixed(0);
                    return label;
                }
            }
        }
    }

    // Bar Parameters
    const barDataDaily = {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [{
            label: 'NPS',
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB',
            pointBorderColor: '#36A2EB',
            pointBackgroundColor: '#36A2EB',
            pointHoverBackgroundColor: '#36A2EB',
            pointHoverBorderColor: '#36A2EB',
            yAxisID: 'y-axis-2'
        }, {
            type: 'bar',
            label: 'Sad',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: '#EE2930',
            borderColor: '#EE2930',
            hoverBackgroundColor: '#EE2930',
            hoverBorderColor: '#EE2930',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Neutral',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: '#F5EE34',
            borderColor: '#F5EE34',
            hoverBackgroundColor: '#F5EE34',
            hoverBorderColor: '#F5EE34',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Happy',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: '#47B749',
            borderColor: '#47B749',
            hoverBackgroundColor: '#47B749',
            hoverBorderColor: '#47B749',
            yAxisID: 'y-axis-1'
        }]
    };

    const barDataHourly = {
        labels: ['00', '01', '02', '03', '04', '05', '06',
            '07', '08', '09', '10', '11', '12', '13', '14',
            '15', '16', '17', '18', '19', '20', '21', '22', '23'
        ],
        datasets: [{
            label: 'NPS',
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB',
            pointBorderColor: '#36A2EB',
            pointBackgroundColor: '#36A2EB',
            pointHoverBackgroundColor: '#36A2EB',
            pointHoverBorderColor: '#36A2EB',
            yAxisID: 'y-axis-2'
        }, {
            type: 'bar',
            label: 'Sad',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: '#EE2930',
            borderColor: '#EE2930',
            hoverBackgroundColor: '#EE2930',
            hoverBorderColor: '#EE2930',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Neutral',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: '#F5EE34',
            borderColor: '#F5EE34',
            hoverBackgroundColor: '#F5EE34',
            hoverBorderColor: '#F5EE34',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Happy',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: '#47B749',
            borderColor: '#47B749',
            hoverBackgroundColor: '#47B749',
            hoverBorderColor: '#47B749',
            yAxisID: 'y-axis-1'
        }]
    };

    const barDataDailyLastWeek = {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [{
            label: 'NPS',
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            borderColor: 'rgba(54, 162, 235, 0.4)',
            backgroundColor: '#rgba(54, 162, 235, 0.4)',
            pointBorderColor: 'rgba(54, 162, 235, 0.4)',
            pointBackgroundColor: 'rgba(54, 162, 235, 0.4)',
            pointHoverBackgroundColor: 'rgba(54, 162, 235, 0.4)',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.4)',
            yAxisID: 'y-axis-2'
        }, {
            type: 'bar',
            label: 'Sad',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: 'rgba(238, 41, 48, 0.4)',
            borderColor: 'rgba(238, 41, 48, 0.4)',
            hoverBackgroundColor: 'rgba(238, 41, 48, 0.4)',
            hoverBorderColor: 'rgba(238, 41, 48, 0.4)',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Neutral',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: 'rgba(245, 238, 52, 0.4)',
            borderColor: 'rgba(245, 238, 52, 0.4)',
            hoverBackgroundColor: 'rgba(245, 238, 52, 0.4)',
            hoverBorderColor: 'rgba(245, 238, 52, 0.4)',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Happy',
            data: [0, 0, 0, 0, 0, 0, 0],
            fill: false,
            backgroundColor: 'rgba(71, 183, 73, 0.4)',
            borderColor: '#rgba(71, 183, 73, 0.4)',
            hoverBackgroundColor: 'rgba(71, 183, 73, 0.4)',
            hoverBorderColor: 'rgba(71, 183, 73, 0.4)',
            yAxisID: 'y-axis-1'
        }]
    };

    const barDataHourlyLastWeek = {
        labels: ['00', '01', '02', '03', '04', '05', '06',
            '07', '08', '09', '10', '11', '12', '13', '14',
            '15', '16', '17', '18', '19', '20', '21', '22', '23'
        ],
        datasets: [{
            label: 'NPS',
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            borderColor: 'rgba(54, 162, 235, 0.4)',
            backgroundColor: '#rgba(54, 162, 235, 0.4)',
            pointBorderColor: 'rgba(54, 162, 235, 0.4)',
            pointBackgroundColor: 'rgba(54, 162, 235, 0.4)',
            pointHoverBackgroundColor: 'rgba(54, 162, 235, 0.4)',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.4)',
            yAxisID: 'y-axis-2'
        }, {
            type: 'bar',
            label: 'Sad',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: 'rgba(238, 41, 48, 0.4)',
            borderColor: 'rgba(238, 41, 48, 0.4)',
            hoverBackgroundColor: 'rgba(238, 41, 48, 0.4)',
            hoverBorderColor: 'rgba(238, 41, 48, 0.4)',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Neutral',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: 'rgba(245, 238, 52, 0.4)',
            borderColor: 'rgba(245, 238, 52, 0.4)',
            hoverBackgroundColor: 'rgba(245, 238, 52, 0.4)',
            hoverBorderColor: 'rgba(245, 238, 52, 0.4)',
            yAxisID: 'y-axis-1'
        }, {
            type: 'bar',
            label: 'Happy',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            fill: false,
            backgroundColor: 'rgba(71, 183, 73, 0.4)',
            borderColor: '#rgba(71, 183, 73, 0.4)',
            hoverBackgroundColor: 'rgba(71, 183, 73, 0.4)',
            hoverBorderColor: 'rgba(71, 183, 73, 0.4)',
            yAxisID: 'y-axis-1'
        }]
    };

    const barOptions = {
        responsive: true,
        tooltips: {
            mode: 'label',
            callbacks: {
                label: function (tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                    if (label) {
                        label += ': ';
                    }
                    label += (tooltipItem.datasetIndex === 0 ? value.toFixed(1) : value.toFixed(0));
                    return label;
                }
            }
        },
        legend: {
            display: false
        },
        elements: {
            line: {
                fill: false
            }
        },
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    display: false
                },
                stacked: true
                //labels: {
                //  show: true
                //}
            }],
            yAxes: [{
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    gridLines: {
                        display: false
                    },
                    labels: {
                        show: true
                    },
                    stacked: true,
                    ticks: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    gridLines: {
                        display: false
                    },
                    labels: {
                        show: true
                    },
                    ticks: {
                        min: 0,
                        max: 100,
                        precision: 0
                    }
                }
            ]
        }
    };

    const setHourlyDataForDay = (day) => {
        for (let i = 0; i < barDataHourly.datasets[0].data.length; i++) {
            let totPresses = 0;
            barDataHourly.datasets[3].data[i] = 0;
            barDataHourly.datasets[2].data[i] = 0;
            barDataHourly.datasets[1].data[i] = 0;
            for (let j = 0; j < props.cluster.devices.length; j++) {
                if (props.cluster.devices[j].stats !== undefined) {
                    const deviceStats = props.cluster.devices[j].stats;
                    //barDataHourly.datasets[0].data[i] = 0;
                    if (deviceStats.thisWeekData.responses[day].hourCnt[i].happyCnt != null) {
                        barDataHourly.datasets[3].data[i] += deviceStats.thisWeekData.responses[day].hourCnt[i].happyCnt;
                        //barDataHourly.datasets[0].data[i] += thisWeekData[day].hourCnt[i].happyCnt;
                        totPresses += deviceStats.thisWeekData.responses[day].hourCnt[i].happyCnt;
                    }
                    if (deviceStats.thisWeekData.responses[day].hourCnt[i].neutralCnt != null) {
                        barDataHourly.datasets[2].data[i] += deviceStats.thisWeekData.responses[day].hourCnt[i].neutralCnt;
                        //barDataHourly.datasets[0].data[i] += thisWeekData[day].hourCnt[i].neutralCnt;
                        totPresses += deviceStats.thisWeekData.responses[day].hourCnt[i].neutralCnt;
                    }
                    if (deviceStats.thisWeekData.responses[day].hourCnt[i].sadCnt != null) {
                        barDataHourly.datasets[1].data[i] += deviceStats.thisWeekData.responses[day].hourCnt[i].sadCnt;
                        //barDataHourly.datasets[0].data[i] += thisWeekData[day].hourCnt[i].sadCnt;
                        totPresses += deviceStats.thisWeekData.responses[day].hourCnt[i].sadCnt;
                    }
                }
            }
            barDataHourly.datasets[0].data[i] =
                (barDataHourly.datasets[3].data[i] / totPresses * 100) -
                (barDataHourly.datasets[1].data[i] / totPresses * 100);
        }
    }

    const setHourlyDataForDayLastWeek = (day) => {
        for (let i = 0; i < barDataHourlyLastWeek.datasets[0].data.length; i++) {
            let totPresses = 0;
            barDataHourlyLastWeek.datasets[3].data[i] = 0;
            barDataHourlyLastWeek.datasets[2].data[i] = 0;
            barDataHourlyLastWeek.datasets[1].data[i] = 0;
            for (let j = 0; j < props.cluster.devices.length; j++) {
                if (props.cluster.devices[j].stats !== undefined) {
                    const deviceStats = props.cluster.devices[j].stats;
                    //barDataHourlyLastWeek.datasets[0].data[i] = 0;
                    if (deviceStats.lastWeekData.responses[day].hourCnt[i].happyCnt != null) {
                        barDataHourlyLastWeek.datasets[3].data[i] += deviceStats.lastWeekData.responses[day].hourCnt[i].happyCnt;
                        //barDataHourlyLastWeek.datasets[0].data[i] += lastWeekData[day].hourCnt[i].happyCnt;
                        totPresses += deviceStats.lastWeekData.responses[day].hourCnt[i].happyCnt;
                    }
                    if (deviceStats.lastWeekData.responses[day].hourCnt[i].neutralCnt != null) {
                        barDataHourlyLastWeek.datasets[2].data[i] += deviceStats.lastWeekData.responses[day].hourCnt[i].neutralCnt;
                        //barDataHourlyLastWeek.datasets[0].data[i] += lastWeekData[day].hourCnt[i].neutralCnt;
                        totPresses += deviceStats.lastWeekData.responses[day].hourCnt[i].neutralCnt;
                    }
                    if (deviceStats.lastWeekData.responses[day].hourCnt[i].sadCnt != null) {
                        barDataHourlyLastWeek.datasets[1].data[i] += deviceStats.lastWeekData.responses[day].hourCnt[i].sadCnt;
                        //barDataHourlyLastWeek.datasets[0].data[i] += lastWeekData[day].hourCnt[i].sadCnt;
                        totPresses += deviceStats.lastWeekData.responses[day].hourCnt[i].sadCnt;
                    }
                }
            }
            barDataHourlyLastWeek.datasets[0].data[i] =
                (barDataHourlyLastWeek.datasets[3].data[i] / totPresses * 100) -
                (barDataHourlyLastWeek.datasets[1].data[i] / totPresses * 100);
        }
    }

    const setHourlyDataForDayExtraData = (id, day) => {
        let l = weekStatsHourly.length - id - 1;
        for (let i = 0; i < weekStatsHourly[l].datasets[0].data.length; i++) {
            let totPresses = 0;
            weekStatsHourly[l].datasets[3].data[i] = 0;
            weekStatsHourly[l].datasets[2].data[i] = 0;
            weekStatsHourly[l].datasets[1].data[i] = 0;
            for (let j = 0; j < props.cluster.devices.length; j++) {
                if (props.cluster.devices[j].weekStats !== undefined) {
                    const deviceStats = props.cluster.devices[j].weekStats[id];
                    if (deviceStats !== undefined) {
                        if (deviceStats.responses[day].hourCnt[i].happyCnt != null) {
                            weekStatsHourly[l].datasets[3].data[i] += deviceStats.responses[day].hourCnt[i].happyCnt;
                            totPresses += deviceStats.responses[day].hourCnt[i].happyCnt;
                        }
                        if (deviceStats.responses[day].hourCnt[i].neutralCnt != null) {
                            weekStatsHourly[l].datasets[2].data[i] += deviceStats.responses[day].hourCnt[i].neutralCnt;
                            totPresses += deviceStats.responses[day].hourCnt[i].neutralCnt;
                        }
                        if (deviceStats.responses[day].hourCnt[i].sadCnt != null) {
                            weekStatsHourly[l].datasets[1].data[i] += deviceStats.responses[day].hourCnt[i].sadCnt;
                            totPresses += deviceStats.responses[day].hourCnt[i].sadCnt;
                        }
                    }
                }
            }
            weekStatsHourly[l].datasets[0].data[i] =
                (weekStatsHourly[l].datasets[3].data[i] / totPresses * 100) -
                (weekStatsHourly[l].datasets[1].data[i] / totPresses * 100);
        }
    }

    const onBarEvent = (elems, event) => {
        if (elems.length !== 0) {
            let index = elems[0]._index;

            setHourlyDataForDay(index);
            switch (index) {
                case 0:
                    dayOfWeek = 'MONDAY';
                    break;
                case 1:
                    dayOfWeek = 'TUESDAY';
                    break;
                case 2:
                    dayOfWeek = 'WEDNESDAY';
                    break;
                case 3:
                    dayOfWeek = 'THURSDAY';
                    break;
                case 4:
                    dayOfWeek = 'FRIDAY';
                    break;
                case 5:
                    dayOfWeek = 'SATERDAY';
                    break;
                case 6:
                    dayOfWeek = 'SUNDAY';
                    break;
                default:
                    dayOfWeek = '';
            }
            if (chartReference !== null)
                //chartReference.chartInstance.update();
                chartReference.update();
            if (chartTitleReference !== null)
                chartTitleReference.innerHTML = 'HOURLY DISTRIBUTION - ' + dayOfWeek + ' THIS WEEK';
        }
    }

    // const barEventLastWeek = (e) => {
    //     if (e.length !== 0){
    //         let index = e[0]._index;
    const onBarEventLastWeek = (elems, event) => {
        if (elems.length !== 0) {
            let index = elems[0]._index;

            setHourlyDataForDayLastWeek(index);
            switch (index) {
                case 0:
                    dayOfLastWeek = 'MONDAY';
                    break;
                case 1:
                    dayOfLastWeek = 'TUESDAY';
                    break;
                case 2:
                    dayOfLastWeek = 'WEDNESDAY';
                    break;
                case 3:
                    dayOfLastWeek = 'THURSDAY';
                    break;
                case 4:
                    dayOfLastWeek = 'FRIDAY';
                    break;
                case 5:
                    dayOfLastWeek = 'SATERDAY';
                    break;
                case 6:
                    dayOfLastWeek = 'SUNDAY';
                    break;
                default:
                    dayOfLastWeek = '';
            }
            if (chartReferenceLastWeek !== null)
                //chartReferenceLastWeek.chartInstance.update();
                chartReferenceLastWeek.update();
            if (chartTitleReferenceLastWeek !== null)
                chartTitleReferenceLastWeek.innerHTML = 'HOURLY DISTRIBUTION - ' +
                dayOfLastWeek + ' LAST WEEK';
        }
    }

    const onBarEventExtraWeek = (week, elems, event) => {
        if (elems.length !== 0) {
            let index = elems[0]._index;

            setHourlyDataForDayExtraData(week, index);
            switch (index) {
                case 0:
                    weekStatsDay[week] = 'MONDAY';
                    break;
                case 1:
                    weekStatsDay[week] = 'TUESDAY';
                    break;
                case 2:
                    weekStatsDay[week] = 'WEDNESDAY';
                    break;
                case 3:
                    weekStatsDay[week] = 'THURSDAY';
                    break;
                case 4:
                    weekStatsDay[week] = 'FRIDAY';
                    break;
                case 5:
                    weekStatsDay[week] = 'SATERDAY';
                    break;
                case 6:
                    weekStatsDay[week] = 'SUNDAY';
                    break;
                default:
                    weekStatsDay[week] = '';
            }
            if (weekStatsHourlyRef[week] !== null)
                weekStatsHourlyRef[week].update();
            if (weekStatsHourlyTitleRef[week] !== null)
                weekStatsHourlyTitleRef[week].innerHTML = 'HOURLY DISTRIBUTION - ' +
                weekStatsDay[week] + ' WEEK ' + weekStatsWeekNo[week];
        }
    }
    //const doughnutEvent = (e) => {
    //    //alert(e)
    //}
    const onDoughnutEvent = (elems, event) => {}

    const onBackClick = (e) => {
        props.onClicked();
    }

    const onBackToDashClick = (e) => {
        props.onDashClicked();
    }

    const onSaveFile = () => {
        let data = 'wk,day,happy,neutral,sad,nps\r\n';
        let week = -1;

        for (let i = 0; i < barDataDaily.datasets[0].data.length; i++) {

            let day = -1;
            if (props.cluster.devices[0].stats !== undefined) {
                const deviceStats = props.cluster.devices[0].stats;
                if (deviceStats.thisWeekData.responses[i].day != null)
                    day = deviceStats.thisWeekData.responses[i].day;
                if (deviceStats.thisWeekData.week != null)
                    week = deviceStats.thisWeekData.week;
            }
            if (day > 0) {
                data += week + ',' + day + ',' +
                    barDataDaily.datasets[3].data[i] + ',' +
                    barDataDaily.datasets[2].data[i] + ',' +
                    barDataDaily.datasets[1].data[i] + ',' +
                    barDataDaily.datasets[0].data[i] + '\r\n';
            } else
                data += week + '\r\n';
        }

        for (let i = 0; i < barDataDailyLastWeek.datasets[0].data.length; i++) {

            let day = -1;
            if (props.cluster.devices[0].stats !== undefined) {
                const deviceStats = props.cluster.devices[0].stats;
                if (deviceStats.lastWeekData.responses[i].day != null)
                    day = deviceStats.lastWeekData.responses[i].day;
                if (deviceStats.lastWeekData.week != null)
                    week = deviceStats.lastWeekData.week;
            }
            if (day > 0) {
                data += week + ',' + day + ',' +
                    barDataDailyLastWeek.datasets[3].data[i] + ',' +
                    barDataDailyLastWeek.datasets[2].data[i] + ',' +
                    barDataDailyLastWeek.datasets[1].data[i] + ',' +
                    barDataDailyLastWeek.datasets[0].data[i] + '\r\n';
            } else
                data += week + '\r\n';
        }

        for (let j = 0; j < weekStatsDaily.length; j++) {
            for (let i = 0; i < weekStatsDaily[j].datasets[0].data.length; i++) {

                let day = i;
                let k = weekStatsDaily.length - j - 1;
                if (props.cluster.devices[0].weekStats[k] !== undefined) {
                    const deviceStats = props.cluster.devices[0].weekStats[k];
                    if (deviceStats.responses[i].day != null)
                        day = deviceStats.responses[i].day;
                    if (deviceStats.week != null)
                        week = deviceStats.week;
                }
                if (day > 0) {
                    data += week + ',' + day + ',' +
                        weekStatsDaily[j].datasets[3].data[i] + ',' +
                        weekStatsDaily[j].datasets[2].data[i] + ',' +
                        weekStatsDaily[j].datasets[1].data[i] + ',' +
                        weekStatsDaily[j].datasets[0].data[i] + '\r\n';
                } else
                    data += week + '\r\n';
            }
        }

        const fileName = props.cluster.name + ' Wk ' + week + '.csv';

        deviceService.saveToFile(data, fileName, 'text/plain');
    }

    const onMoreData = (e) => {
        if (props.onMoreDataClicked != null)
            props.onMoreDataClicked();
    }

    // Make a deep copy of bar data
    const makeDeepCopy = (src) => {
        let labels = [...src.labels];
        let datasets = src.datasets.map(i => {
            let data = [...i.data];

            return {
                ...i,
                data
            };
        });
        return {
            labels,
            datasets
        };
    }

    // Populate data
    let dayOfWeek = 'MONDAY';
    let dayOfLastWeek = 'MONDAY';
    let stats = {
        aButtonPresses: 0,
        bButtonPresses: 0,
        cButtonPresses: 0,
        dButtonPresses: 0,
        eButtonPresses: 0
    };
    if (props.cluster !== undefined) {
        for (let i = 0; i < props.cluster.devices.length; i++) {
            if (props.cluster.devices[i].stats !== undefined) {
                stats.aButtonPresses += props.cluster.devices[i].stats.aButtonPresses;
                stats.bButtonPresses += props.cluster.devices[i].stats.bButtonPresses;
                stats.cButtonPresses += props.cluster.devices[i].stats.cButtonPresses;
                stats.dButtonPresses += props.cluster.devices[i].stats.dButtonPresses;
                stats.eButtonPresses += props.cluster.devices[i].stats.eButtonPresses;
            }
        }
    }
    const total = stats.aButtonPresses + stats.bButtonPresses + stats.cButtonPresses +
        stats.dButtonPresses + stats.eButtonPresses;

    if (total > 0) {
        positivePrecentage = (stats.aButtonPresses + stats.bButtonPresses + stats.cButtonPresses) /
            total * 100;
    } else
        positivePrecentage = 0;

    // Set dougnut data
    doughnutData.datasets[0].data[2] = stats.aButtonPresses / total * 100;
    doughnutData.datasets[0].data[1] = stats.cButtonPresses / total * 100;
    doughnutData.datasets[0].data[0] = stats.eButtonPresses / total * 100;

    // Make copies of bar data
    let weekStatsDaily = [];
    let weekStatsHourly = []
    let weekStatsDay = [];
    let weekStatsHourlyRef = [];
    let weekStatsHourlyTitleRef = [];
    let weekStatsWeekNo = [];
    let weekJsx = null;
    if (props.dash && props.cluster.devices[0].weekStats !== undefined) {
        for (let i = 0; i < props.cluster.devices[0].weekStats.length; i++) {
            weekStatsDaily.push(makeDeepCopy(barDataDaily))
            weekStatsHourly.push(makeDeepCopy(barDataHourly));
            weekStatsDay.push('MONDAY');
            weekStatsHourlyRef.push(null);
            weekStatsHourlyTitleRef.push(null);
            weekStatsWeekNo.push(0);
        }
    }

    // Set this weeks data
    for (let i = 0; i < barDataDaily.datasets[0].data.length; i++) {

        let totPresses = 0;
        barDataDaily.datasets[3].data[i] = 0;
        barDataDaily.datasets[2].data[i] = 0;
        barDataDaily.datasets[1].data[i] = 0;
        for (let j = 0; j < props.cluster.devices.length; j++) {
            if (props.cluster.devices[j].stats !== undefined) {
                const deviceStats = props.cluster.devices[j].stats;
                //barDataDaily.datasets[0].data[i] = 0;
                if (deviceStats.thisWeekData.responses[i].happyCnt != null) {
                    barDataDaily.datasets[3].data[i] += deviceStats.thisWeekData.responses[i].happyCnt;
                    //barDataDaily.datasets[0].data[i] += thisWeekData[i].happyCnt;
                    totPresses += deviceStats.thisWeekData.responses[i].happyCnt;
                }
                if (deviceStats.thisWeekData.responses[i].neutralCnt != null) {
                    barDataDaily.datasets[2].data[i] += deviceStats.thisWeekData.responses[i].neutralCnt;
                    //barDataDaily.datasets[0].data[i] += thisWeekData[i].neutralCnt;
                    totPresses += deviceStats.thisWeekData.responses[i].neutralCnt;
                }
                if (deviceStats.thisWeekData.responses[i].sadCnt != null) {
                    barDataDaily.datasets[1].data[i] += deviceStats.thisWeekData.responses[i].sadCnt;
                    //barDataDaily.datasets[0].data[i] += thisWeekData[i].sadCnt;
                    totPresses += deviceStats.thisWeekData.responses[i].sadCnt;
                }
            }
        }
        barDataDaily.datasets[0].data[i] = (barDataDaily.datasets[3].data[i] / totPresses * 100) -
            (barDataDaily.datasets[1].data[i] / totPresses * 100);
    }
    // These are only for dash views
    if (props.dash) {
        // Set hourly data
        setHourlyDataForDay(0);

        // Set last weeks data
        for (let i = 0; i < barDataDaily.datasets[0].data.length; i++) {

            let totPresses = 0;
            barDataDailyLastWeek.datasets[3].data[i] = 0;
            barDataDailyLastWeek.datasets[2].data[i] = 0;
            barDataDailyLastWeek.datasets[1].data[i] = 0;
            for (let j = 0; j < props.cluster.devices.length; j++) {
                if (props.cluster.devices[j].stats !== undefined) {
                    const deviceStats = props.cluster.devices[j].stats;
                    //barDataDailyLastWeek.datasets[0].data[i] = 0;
                    if (deviceStats.lastWeekData.responses[i].happyCnt != null) {
                        barDataDailyLastWeek.datasets[3].data[i] += deviceStats.lastWeekData.responses[i].happyCnt;
                        //barDataDailyLastWeek.datasets[0].data[i] += lastWeekData[i].happyCnt;
                        totPresses += deviceStats.lastWeekData.responses[i].happyCnt;
                    }
                    if (deviceStats.lastWeekData.responses[i].neutralCnt != null) {
                        barDataDailyLastWeek.datasets[2].data[i] += deviceStats.lastWeekData.responses[i].neutralCnt;
                        //barDataDailyLastWeek.datasets[0].data[i] += lastWeekData[i].neutralCnt;
                        totPresses += deviceStats.lastWeekData.responses[i].neutralCnt;
                    }
                    if (deviceStats.lastWeekData.responses[i].sadCnt != null) {
                        barDataDailyLastWeek.datasets[1].data[i] += deviceStats.lastWeekData.responses[i].sadCnt;
                        //barDataDailyLastWeek.datasets[0].data[i] += lastWeekData[i].sadCnt;
                        totPresses += deviceStats.lastWeekData.responses[i].sadCnt;
                    }
                }
            }
            barDataDailyLastWeek.datasets[0].data[i] = (barDataDailyLastWeek.datasets[3].data[i] / totPresses * 100) -
                (barDataDailyLastWeek.datasets[1].data[i] / totPresses * 100);
        }
        // Set last weeks horly data
        setHourlyDataForDayLastWeek(0);

        // Populate extra data
        for (let k = 0; k < weekStatsDaily.length; k++) {
            let l = weekStatsDaily.length - k - 1;
            for (let i = 0; i < weekStatsDaily[l].datasets[0].data.length; i++) {

                let totPresses = 0;
                weekStatsDaily[l].datasets[3].data[i] = 0;
                weekStatsDaily[l].datasets[2].data[i] = 0;
                weekStatsDaily[l].datasets[1].data[i] = 0;
                for (let j = 0; j < props.cluster.devices.length; j++) {
                    if (props.cluster.devices[j].weekStats !== undefined) {
                        const deviceStats = props.cluster.devices[j].weekStats[k];
                        if (deviceStats !== undefined) {
                            if (deviceStats.responses[i].happyCnt != null) {
                                weekStatsDaily[l].datasets[3].data[i] += deviceStats.responses[i].happyCnt;
                                totPresses += deviceStats.responses[i].happyCnt;
                            }
                            if (deviceStats.responses[i].neutralCnt != null) {
                                weekStatsDaily[l].datasets[2].data[i] += deviceStats.responses[i].neutralCnt;
                                totPresses += deviceStats.responses[i].neutralCnt;
                            }
                            if (deviceStats.responses[i].sadCnt != null) {
                                weekStatsDaily[l].datasets[1].data[i] += deviceStats.responses[i].sadCnt;
                                totPresses += deviceStats.responses[i].sadCnt;
                            }
                            weekStatsWeekNo[l] = deviceStats.week;
                        }
                    }
                }
                weekStatsDaily[l].datasets[0].data[i] = (weekStatsDaily[l].datasets[3].data[i] / totPresses * 100) -
                    (weekStatsDaily[l].datasets[1].data[i] / totPresses * 100);
            }
            // Set extra weeks horly data
            setHourlyDataForDayExtraData(k, 0);
        }

        // Build extra data JSX
        weekJsx = weekStatsDaily.map((i, k) => {
            let week = weekStatsWeekNo[k];
            return ( <
                Row key = {
                    k
                } >
                <
                Col xs = {
                    6
                } >
                <
                div className = 'DetailLastMask' >
                <
                div className = 'DetailLastDaily' > DAILY DISTRIBUTION - WEEK {
                    week
                } < /div> <
                Bar data = {
                    i
                }
                options = {
                    barOptions
                }
                getElementAtEvent = {
                    (elems, event) => {
                        onBarEventExtraWeek(k, elems, event)
                    }
                }
                /> < /
                div > <
                /Col> <
                Col xs = {
                    6
                } >
                <
                div className = 'DetailLastMask' >
                <
                div ref = {
                    (reference) => weekStatsHourlyTitleRef[k] = reference
                }
                className = 'DetailLastHourly' > HOURLY DISTRIBUTION - {
                    weekStatsDay[k]
                }
                WEEK {
                    week
                } < /div> <
                Bar data = {
                    weekStatsHourly[k]
                }
                options = {
                    barOptions
                }
                getChart = {
                    (chart) => {
                        weekStatsHourlyRef[k] = chart
                    }
                }
                /> < /
                div > <
                /Col> < /
                Row >
            );
        });
    }

    // Get logo
    let logo = null;
    if (props.cluster.uiConfig != null) {
        try {
            const uiConfig = JSON.parse(props.cluster.uiConfig);

            if (uiConfig.buzzCSA) {
                if (uiConfig.buzzCSA.logo) {
                    logo = uiConfig.buzzCSA.logo;
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    // Disable stuff for reports
    if (!props.dash) {
        doughnutOptions.animation = {
            duration: 0
        };
        doughnutOptions.tooltips = {
            enabled: false
        };
        barOptions.animation = {
            duration: 0
        };
        barOptions.tooltips = {
            enabled: false
        };
    }

    return ( <
        Auxiliary > {
            props.dash ?
            <
            Row >
            <
            Breadcrumb >
            <
            Breadcrumb.Item href = "#"
            onClick = {
                onBackToDashClick
            } > Dashboard < /Breadcrumb.Item> <
            Breadcrumb.Item href = "#"
            onClick = {
                onBackClick
            } > {
                'Overview - ' + props.cluster.name
            } < /Breadcrumb.Item> <
            Breadcrumb.Item active > {
                'Detail'
            } < /Breadcrumb.Item> < /
            Breadcrumb > <
            /Row> : <
            Row >
            <
            h3 style = {
                {
                    margin: '0 0 0 20px'
                }
            } > {
                props.device.name
            } < /h3> < /
            Row >
        } <
        Row >
        <
        Col xs = {
            7
        } > {
            props.dash ?
            <
            Auxiliary >
            <
            Button bsStyle = 'primary'
            onClick = {
                onBackClick
            } > Go Back < /Button> <
            span > < /span> <
            Button bsStyle = 'success'
            onClick = {
                onSaveFile
            } > Export Data < /Button> <
            span > < /span> <
            Button bsStyle = 'info'
            onClick = {
                onMoreData
            } > Get More Data < /Button> < /
            Auxiliary > : null
        } <
        div className = 'DetailPanel' >
        <
        div className = 'DetailSummaryHeading' > WEEKLY DISTRIBUTION < /div> <
        Col xs = {
            4
        } >
        <
        Doughnut data = {
            doughnutData
        }
        width = {
            150
        }
        height = {
            150
        }
        options = {
            doughnutOptions
        }
        plugins = {
            doughnutPlugins
        }
        //onElementsClick={props.dash ? doughnutEvent : null}
        getElementAtEvent = {
            (elems, event) => {
                onDoughnutEvent(elems, event)
            }
        }
        /> < /
        Col > <
        Col xs = {
            2
        } >
        <
        img src = {
            happy
        }
        alt = 'Happy'
        className = 'DetailSummaryImage' / >
        <
        div className = 'DetailSummaryPercentage' > {
            total > 0 ? (stats.aButtonPresses / total * 100).toFixed(0) : 0
        } % < /div> <
        div className = 'DetailSummaryCount' > {
            stats.aButtonPresses
        } < /div> < /
        Col > <
        Col xs = {
            2
        } >
        <
        img src = {
            neutral
        }
        alt = 'Neutral'
        className = 'DetailSummaryImage' / >
        <
        div className = 'DetailSummaryPercentage' > {
            total > 0 ? (stats.cButtonPresses / total * 100).toFixed(0) : 0
        } % < /div> <
        div className = 'DetailSummaryCount' > {
            stats.cButtonPresses
        } < /div> < /
        Col > <
        Col xs = {
            2
        } >
        <
        img src = {
            sad
        }
        alt = 'Sad'
        className = 'DetailSummaryImage' / >
        <
        div className = 'DetailSummaryPercentage' > {
            total > 0 ? (stats.eButtonPresses / total * 100).toFixed(0) : 0
        } % < /div> <
        div className = 'DetailSummaryCount' > {
            stats.eButtonPresses
        } < /div> < /
        Col > <
        div className = 'DetailSummaryResponse' > {
            total + ' Responses'
        } < /div> < /
        div > <
        /Col> <
        Col xs = {
            5
        } > {
            logo != null ?
            <
            img className = 'DetailLogo'
            src = {
                logo
            }
            alt = 'Logo'
            title = 'Logo' / >
            :
                null
        } <
        /Col> < /
        Row > {
            props.dash ?
            <
            Row >
            <
            Col xs = {
                6
            } >
            <
            div className = 'DetailPanel' >
            <
            div className = 'DetailWeekDaily' > DAILY DISTRIBUTION - THIS WEEK < /div> <
            Bar
            data = {
                barDataDaily
            }
            options = {
                barOptions
            }
            //onElementsClick={barEvent}
            getElementAtEvent = {
                (elems, event) => {
                    onBarEvent(elems, event)
                }
            }
            /> < /
            div > <
            /Col> <
            Col xs = {
                6
            } >
            <
            div className = 'DetailPanel' >
            <
            div ref = {
                (reference) => chartTitleReference = reference
            }
            className = 'DetailWeekHourly' > HOURLY DISTRIBUTION - {
                dayOfWeek
            }
            THIS WEEK < /div> <
            Bar
            data = {
                barDataHourly
            }
            options = {
                barOptions
            }
            //ref={(reference) => (chartReference = reference)}
            getChart = {
                (chart) => {
                    chartReference = chart
                }
            }
            /> < /
            div > <
            /Col> < /
            Row > :
                <
                Row >
                <
                Col xs = {
                    12
                } >
                <
                div className = 'DetailPanel' >
                <
                div className = 'DetailWeekDaily' > DAILY DISTRIBUTION < /div> <
            Bar
            data = {
                barDataDaily
            }
            options = {
                barOptions
            }
            /> < /
            div > <
            /Col> < /
            Row >
        } {
            props.dash ?
                <
                Auxiliary >
                <
                Row >
                <
                Col xs = {
                    6
                } >
                <
                div className = 'DetailLastMask' >
                <
                div className = 'DetailLastDaily' > DAILY DISTRIBUTION - LAST WEEK < /div> <
            Bar
            data = {
                barDataDailyLastWeek
            }
            options = {
                barOptions
            }
            //onElementsClick={barEventLastWeek}
            getElementAtEvent = {
                (elems, event) => {
                    onBarEventLastWeek(elems, event)
                }
            }
            /> < /
            div > <
                /Col> <
            Col xs = {
                    6
                } >
                <
                div className = 'DetailLastMask' >
                <
                div ref = {
                    (reference) => chartTitleReferenceLastWeek = reference
                }
            className = 'DetailLastHourly' > HOURLY DISTRIBUTION - {
                dayOfLastWeek
            }
            LAST WEEK < /div> <
            Bar
            data = {
                barDataHourlyLastWeek
            }
            options = {
                barOptions
            }
            //ref={(reference) => (chartReferenceLastWeek = reference)}
            getChart = {
                (chart) => {
                    chartReferenceLastWeek = chart
                }
            }
            /> < /
            div > <
                /Col> < /
                Row > {
                    weekJsx
                } <
                /Auxiliary> :
            null
        } <
        /Auxiliary>
    );
};

export default clusterDetail;